module.exports = __webpack_public_path__ + "static/media/26-6.0e60b69b.mp3";